module.exports = __webpack_public_path__ + "img/right.bb6f32bd.svg";